var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfiteam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3FB777;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,47.2c-12.2,0-22.2-10-22.2-22.2S12.8,2.8,25,2.8s22.2,10,22.2,22.2c0,2.1-0.3,4.2-0.9,6.3l-0.7-0.2 c0.6-2,0.9-4,0.9-6.1c0-11.9-9.6-21.5-21.5-21.5C13.1,3.5,3.5,13.1,3.5,25S13.1,46.5,25,46.5V47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,50C11.2,50,0,38.8,0,25c0-2.4,0.3-4.8,1-7.1l0.7,0.2c-0.7,2.2-1,4.5-1,6.9c0,13.4,10.9,24.3,24.3,24.3 S49.3,38.4,49.3,25S38.4,0.7,25,0.7V0c13.8,0,25,11.2,25,25S38.8,50,25,50z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.5,19.3h-5.3v-1.6c0-1.1-0.9-2-2-2h-7.4c-1.1,0-2,0.9-2,2v1.6h-5.3c-0.7,0-1.2,0.5-1.2,1.2v9.1 c0,0.5,0.3,1,0.8,1.2v5.7c0,0.7,0.5,1.2,1.2,1.2h20.4c0.7,0,1.2-0.5,1.2-1.2v-5.7c0.5-0.2,0.8-0.6,0.8-1.2v-9.1 C37.7,19.8,37.1,19.3,36.5,19.3L36.5,19.3z M20.5,17.6c0-0.7,0.5-1.2,1.2-1.2h7.4c0.7,0,1.2,0.5,1.2,1.2v1.6h-0.8v-1.6 c0-0.2-0.2-0.4-0.4-0.4h-7.4c-0.2,0-0.4,0.2-0.4,0.4v1.6h-0.8V17.6z M28.7,19.3h-6.5V18h6.5V19.3z M36,36.5c0,0.2-0.2,0.4-0.4,0.4 H15.2c-0.2,0-0.4-0.2-0.4-0.4v-5.6l9,1.2v1c0,0.7,0.5,1.2,1.2,1.2h0.8c0.7,0,1.2-0.5,1.2-1.2v-1l9-1.2V36.5z M26.2,33.2 c0,0.2-0.2,0.4-0.4,0.4H25c-0.2,0-0.4-0.2-0.4-0.4v-2.5c0-0.2,0.2-0.4,0.4-0.4h0.8c0.2,0,0.4,0.2,0.4,0.4V33.2z M36.9,29.6 c0,0.2-0.1,0.4-0.4,0.4l-0.1,0L27,31.3v-0.6c0-0.7-0.5-1.2-1.2-1.2H25c-0.7,0-1.2,0.5-1.2,1.2v0.6L14.3,30c-0.2,0-0.4-0.2-0.4-0.4 v-9.1c0-0.2,0.2-0.4,0.4-0.4h22.1c0.2,0,0.4,0.2,0.4,0.4V29.6z M36.9,29.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiteam);
export default __webpack_public_path__ + "static/media/profiteam.49b5d4ce8ff164d8d12c969c1ee80c01.svg";
export { ForwardRef as ReactComponent };